// src/components/WithdrawalsPage.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { withdrawalStatusLabels, withdrawalStatusColors } from '../utils/withdrawalStatusLabels';

const api = axios.create({
  baseURL: 'https://api.blackroq.pro/api',
  withCredentials: true,
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

export default function WithdrawalsPage() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/withdrawal/history')
      .then(res => {
        setWithdrawals(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur chargement retraits', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center mt-5">Chargement...</p>;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Mes retraits</h2>
      {withdrawals.length === 0 ? (
        <p>Aucun retrait pour le moment.</p>
      ) : (
        withdrawals.map(w => (
          <div key={w._id} className="card mb-3 shadow-sm">
            <div className="card-body">
              <p><strong>Montant demandé :</strong> {w.amount} USDT</p>
              <p><strong>Montant net :</strong> {w.netAmount} USDT</p>
              <p><strong>Frais :</strong> {w.fee} USDT</p>
              <p>
                <strong>Statut :</strong>{' '}
                <span
                  className="badge"
                  style={{
                    backgroundColor: withdrawalStatusColors[w.status] || '#666',
                    color: '#fff'
                  }}
                >
                  {withdrawalStatusLabels[w.status] || w.status}
                </span>
              </p>
              <p><strong>Adresse :</strong> {w.walletAddress}</p>
              <p><strong>Date :</strong> {new Date(w.createdAt).toLocaleString('fr-FR')}</p>
              {w.txId && <p><strong>TxID :</strong> {w.txId}</p>}
            </div>
          </div>
        ))
      )}
    </div>
  );
}